export default "__VITE_ASSET__Cth_JOV8__"